const __DEV__ = false;

import * as React from 'react';

var useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
var useEnhancedEffect$1 = useEnhancedEffect;

export { useEnhancedEffect$1 as default };
//# sourceMappingURL=use-enhanced-effect.js.map
